module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGe19403e86ef04d13e36aa9b8aa36b759.e19403e8.png";